















import Vue from 'vue'
import Avatar from './avatar.vue'

export default Vue.extend({
  props: {
    url: {
      type: String
    }
  },

  components: {
    Avatar
  }
})
